import React, { useState, useEffect } from 'react';

const NotificationToast = ({ notification, onClose, onMarkAsRead }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Mostrar la notificación después de un pequeño delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Auto-ocultar después de 5 segundos (si no está siendo hover)
    const autoHideTimer = setTimeout(() => {
      if (!isHovered) {
        handleClose();
      }
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(autoHideTimer);
    };
  }, [isHovered]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Delay para la animación
  };

  const handleMarkAsRead = () => {
    onMarkAsRead();
    handleClose();
  };

  const getNotificationIcon = (tipo) => {
    const icons = {
      ASIGNACION: '👤',
      COMPLETACION: '✅',
      VENCIMIENTO: '⚠️',
      SISTEMA: '🔔',
      ARCHIVO: '📁',
      EXPEDIENTE: '📋'
    };
    return icons[tipo] || '🔔';
  };

  const getNotificationColor = (tipo) => {
    const colors = {
      ASIGNACION: 'primary',
      COMPLETACION: 'success',
      VENCIMIENTO: 'warning',
      SISTEMA: 'info',
      ARCHIVO: 'secondary',
      EXPEDIENTE: 'primary'
    };
    return colors[tipo] || 'secondary';
  };

  const getNotificationBorderColor = (tipo) => {
    const colors = {
      ASIGNACION: '#007bff',
      COMPLETACION: '#28a745',
      VENCIMIENTO: '#ffc107',
      SISTEMA: '#17a2b8',
      ARCHIVO: '#6c757d',
      EXPEDIENTE: '#007bff'
    };
    return colors[tipo] || '#6c757d';
  };

  return (
    <div
      className={`notification-toast ${isVisible ? 'show' : ''}`}
      style={{
        borderLeft: `4px solid ${getNotificationBorderColor(notification.tipo)}`
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="notification-toast-header">
        <div className="notification-toast-icon">
          <span className={`badge badge-${getNotificationColor(notification.tipo)}`}>
            {getNotificationIcon(notification.tipo)}
          </span>
        </div>
        <div className="notification-toast-title">
          {notification.titulo}
        </div>
        <button
          className="notification-toast-close"
          onClick={handleClose}
          title="Cerrar"
        >
          ×
        </button>
      </div>
      
      <div className="notification-toast-body">
        {notification.mensaje}
      </div>
      
      <div className="notification-toast-actions">
        {!notification.leida && (
          <button
            className="btn btn-sm btn-outline-primary mr-2"
            onClick={handleMarkAsRead}
          >
            Marcar como leída
          </button>
        )}
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={handleClose}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;
